import localDB from "./localDB";
let GLOBAL = require('./globals');

const StoreCategoryData = {
    async listAll() {
        let response = await fetch(`${GLOBAL.BASE_URL}store-categories-all`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async addCategoryStore(data, res) {
        await fetch(`${GLOBAL.BASE_URL}store-categories`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async deleteCategoryStore(id, res) {
        await fetch(`${GLOBAL.BASE_URL}store-categories/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async updateCategoryStore(data, res) {
        await fetch(`${GLOBAL.BASE_URL}store-categories/${data.id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    }
};

export default StoreCategoryData;



// WEBPACK FOOTER //
// ./src/data/StoreCategoryData.js